import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useLayoutEffect,
} from "react";
import { Container, Row, Col } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import "../KfinBranches/KfinBranches.css";
import amccallogo from "../../../images/amc_logo-call.png";
import locationlogo from "../../../images/amc_logo-location.png";
import animation from "../../../images/jm-animation.gif";
import { Vortex } from "react-loader-spinner";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_indiaHigh from "@amcharts/amcharts5-geodata/indiaHigh";
import Select from "react-select";
import { trackEvent, trackPageView } from "../../utils/tracking";

function KfinBranches() {
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  const [data, setData] = useState("");
  const [zone, setzone] = useState("");
  const [citys, setCitys] = useState("");
  const [DataCities, setDataCities] = useState([]);
  const [DataCitiesdrop, setDataCitis] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [option, setOption] = useState(null);
  // useEffect(() => {
  //     setloadingshow(true);
  //     GetPostMethodData(BaseURL + "GetKfinDrop", {
  //         "IVzone": zone,
  //     }).then((data) => {
  //         if (data.data != null && data.data.length > 0) {
  //             setDataCitis(DecryptAESdata(data.data));
  //             setloadingshow(false);
  //         }
  //     });
  // }, [BaseURL, zone]);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetKfinDrop", {
      IVzone: zone,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataCitis(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL, zone]);

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/Reach-Us/KFinBranches",
      "jmf_reach-us_kfin-branches"
    );
   
    trackEvent({
      category: "Dynamic Page",
      action: "KFin Branches Page Loaded",
      label: "jmf_reach-us_kfin-branches",
      // value: 1,
    });
  }, []);

  let cityOptions = [];

  if (Array.isArray(DataCitiesdrop)) {
    cityOptions = DataCitiesdrop.map(({ branchname }) => ({
      value: branchname,
      label: branchname,
    }));
  }

  const getDistinctCities = () => {
    return DataCitiesdrop.reduce((uniqueCities, city) => {
      if (!uniqueCities.includes(city.branchname)) {
        uniqueCities.push(city.branchname);
      }
      return uniqueCities;
    }, []);
  };

  cityOptions = getDistinctCities().map((city) => ({
    value: city,
    label: city,
  }));
  cityOptions.unshift({ value: "", label: "All Cities" });

  const handleCityChange = (selectedOption) => {
    setOption(selectedOption);
    setCitys(selectedOption.value);
    // GetPostMethodData(BaseURL + "GetKfinBranchaes", {
    //     "IVzone": zone,
    //     "IVcity": citys
    // }).then((data) => {
    //     if (data.data != null && data.data.length > 0) {
    //         setData(DecryptAESdata(data.data));
    //         IndiaChart(DecryptAESdata(data.data));
    //         onchangedata(DecryptAESdata(data.data))
    //         setDataCities(DecryptAESdata(data.data))
    //         setloadingshow(false);
    //     }

    // }, [zone, citys]);
  };
  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetKfinBranchaes", {
      IVzone: zone,
      IVcity: citys,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        var mainChartDiv = document.getElementById("mainChartDiv");
        mainChartDiv.innerHTML = "";
        var chartdiv = document.createElement("div");
        chartdiv.id = "chartdiv";
        mainChartDiv.appendChild(chartdiv);
        IndiaChart(DecryptAESdata(data.data));
        onchangedata(DecryptAESdata(data.data));
        setDataCities(DecryptAESdata(data.data));
        setloadingshow(false);
        //   }, 500);
      }
    });
  }, [BaseURL, citys, zone]);

  const onchangedata = (data) => {
    if (citys != "" && zone != "") {
      GetPostMethodData(BaseURL + "GetKfinBranchaes", {
        IVzone: zone,
        IVcity: citys,
      }).then((data) => {
        if (data.data != null && data.data.length > 0) {
          setDataCities(DecryptAESdata(data.data));
        }
      });
    }
  };
  const changeMap = (t_data) => {
    setzone();
    setCitys();

    var mainChartDiv = document.getElementById("mainChartDiv");
    mainChartDiv.innerHTML = "";
    var chartdiv = document.createElement("div");
    chartdiv.id = "chartdiv";
    mainChartDiv.appendChild(chartdiv);
    IndiaChart(t_data);
  };
  useLayoutEffect(() => {
    am5.addLicense("AM5C420959785");
    am5.addLicense("AM5M420959785");
  });
  const IndiaChart = (t_data) => {
    var root = am5.Root.new("chartdiv");

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    var chart = root.container.children.push(
      am5map.MapChart.new(root, {
        panX: "none",
        panY: "none",
        wheelY: "none",
        projection: am5map.geoNaturalEarth1(),
        rotationZ: -16,
        panX: "rotateX",
        wheelY: "zoom",
        wheelX: "zoom",
        minZoomLevel: 0.5,
        maxZoomLevel: 16,
      })
    );

    // Create polygon series
    var polygonSeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_indiaHigh,
        fill: am5.color(0xd9d9d9),
        stroke: am5.color(0xffffff),

        // tooltip: am5.Tooltip.new(root, {
        //     pointerOrientation: "horizontal"
        //   })
        //exclude: ["AQ"]
      })
    );
    chart.seriesContainer.events.disableType("doublehit");
    var pointSeries = chart.series.push(am5map.MapPointSeries.new(root, {}));

    pointSeries.bullets.push(function () {
      var circle = am5.Picture.new(root, {
        // radius: 4,
        tooltipY: 4,
        src: "/marker.png",
        dy: -17,
        dx: -7,
        fill: am5.color(0x13589a),
        stroke: root.interfaceColors.get("background"),
        opacity: 1,
        tooltipHTML: `<div style="width: 200px; overflow-wrap: break-word;color:#fff; font-size:14px;font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";">
            <span style=color:#fff;font-size:17px">{title}</span><br>
            {description}
                </div>`,

        // tooltipText:"asdasd",

        // populateText: true,
        // interactive: true,
        // tooltipPosition: "fixed",
        // keepTargetHover: true
        // "State: {title}<br>Population: {description}"
      });
      circle.events.on("click", function (ev) {
        // cursorMoved(ev.target.dataItem)
      });
      return am5.Bullet.new(root, {
        sprite: circle,
      });
    });

    var cities = t_data;

    for (var i = 0; i < cities.length; i++) {
      var city = cities[i];
      addCity(city.Longitude, city.Latitude, city.branchname, city.address);
    }

    function addCity(Longitude, Latitude, title, description) {
      pointSeries.data.push({
        geometry: { type: "Point", coordinates: [Longitude, Latitude] },
        title: title,
        description: description,
        // populateText: true,
      });
    }

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-pan-zoom/#Zoom_control
    chart.set("zoomControl", am5map.ZoomControl.new(root, {}));

    chart.appear(1000, 100);
  };

  // const showInMapClicked = (longitude,latitude) => {
  //     window.open("https://maps.google.com?q="+longitude+","+latitude );
  //   };
  function showInMapClicked(Longitude, Latitude, address) {
    window.open(
      "https://maps.google.com?q=" + Longitude + "," + Latitude + "," + address
    );
  }

  var actionButtons = document.querySelectorAll(".action-button");
  actionButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      this.classList.toggle("active");
    });
  });

  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  return (
    <>
      {/* <div id="chartdiv"></div> */}
      <main className="amc-branches-main">
        <Container>
          <Row>
            <h2>KFin Technologies Ltd. Investor Service Centers</h2>
            <Col lg={7} md={6} sm={12}>
              <div className="map-container">
                <div id="mainChartDiv">
                  <div id="chartdiv"></div>
                </div>
              </div>
            </Col>
            <Col
              lg={5}
              md={6}
              sm={12}
              className=" kfin-branches-section jm-branch-section"
            >
              <div className="kfin-branches-container">
                <div className="across-country-container">
                  <h3>KFin branches across the country</h3>
                  <div className="across-country-tabs">
                    <div className="tab-list" id="zone-button">
                      <button
                        value=""
                        className={zone === "" ? "active" : ""}
                        onClick={(event) => {
                          setzone(event.target.value);
                          setCitys("");
                          setOption(null);
                        }}
                        aria-label="button for all zone"
                      >
                        All
                      </button>
                      <button
                        value="North"
                        className={zone === "North" ? "active" : ""}
                        onClick={(event) => {
                          setzone(event.target.value);
                          setCitys("");
                          setOption(null);
                        }}
                        aria-label="button for north zone"
                      >
                        North
                      </button>
                      <button
                        value="East"
                        className={zone === "East" ? "active" : ""}
                        onClick={(event) => {
                          setzone(event.target.value);
                          setCitys("");
                          setOption(null);
                        }}
                        aria-label="button for east zone"
                      >
                        East
                      </button>
                      <button
                        value="West"
                        className={zone === "West" ? "active" : ""}
                        onClick={(event) => {
                          setzone(event.target.value);
                          setCitys("");
                          setOption(null);
                        }}
                        aria-label="button for west zone"
                      >
                        West
                      </button>
                      <button
                        value="South"
                        className={zone === "South" ? "active" : ""}
                        onClick={(event) => {
                          setzone(event.target.value);
                          setCitys("");
                          setOption(null);
                        }}
                        aria-label="button for south zone"
                      >
                        South
                      </button>
                    </div>
                    <div className="select-container" id="zone-drop">
                      <select
                        className="fund-selector"
                        onChange={(event) => {
                          setzone(event.target.value);
                          setCitys("");
                          setOption(null);
                        }}
                      >
                        <option value="">All</option>
                        <option value="North">North</option>
                        <option value="East">East</option>
                        <option value="West">West</option>
                        <option value="South">South</option>
                      </select>
                      {/* <i className="fa fa-caret-down" aria-hidden="true"></i> */}
                    </div>
                    {/* <div className="select-container">
                                            <select id="fund" className="fund-selector" onChange={(event) => { setCitys(event.target.value) }}>
                                                <option value=''>All Cities</option>
                                               
                                                {DataCitiesdrop &&
                          getDistinctValuesAsDict(DataCitiesdrop, "branchname").map(({ branchname }) => (
                                               
                                                    <option value={branchname} >{branchname}</option>

                                                )
                                                )}
                                            </select>
                                            <i className="fa fa-caret-down" aria-hidden="true"></i>
                                        </div> */}
                    <div className="select-container">
                      <Select
                        id="fund"
                        className="custom-dropdown"
                        options={cityOptions}
                        isSearchable
                        placeholder="Search for a city or select from the list..."
                        onChange={handleCityChange}
                        value={option}
                      />
                    </div>
                    <div className="location fixed-height-city">
                      {loadingshow ? (
                        <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                          <img src={animation} alt="" aria-hidden="true" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        <div>
                          {DataCities.length === 0 ? (
                            <h5 className="errormsgComNew" role="alert">
                              No Data Available
                            </h5>
                          ) : (
                            <>
                              {DataCities &&
                                DataCities.map(
                                  ({
                                    branchname,
                                    address,
                                    landline,
                                    Latitude,
                                    Longitude,
                                  }) => (
                                    <div className="location">
                                      <div className="city-name">
                                        {branchname}
                                      </div>

                                      <div className="add-call-container">
                                        <div className="address">
                                          <div className="logo-container">
                                            <img
                                              src={locationlogo}
                                              alt="locationlogo"
                                            />
                                            <p>{address}</p>
                                          </div>
                                          {/* <p>{address}</p> */}
                                        </div>
                                        <div className="call">
                                          <div className="logo-container">
                                            <img
                                              src={amccallogo}
                                              alt="amccallogo"
                                            />
                                            <p>{landline}</p>
                                          </div>
                                          {/* <p>{landline}</p> */}
                                        </div>
                                        {/* <span>LocatUs</span> */}
                                      </div>
                                      <div className="btn-locateus">
                                        <span
                                          onClick={() =>
                                            showInMapClicked(
                                              Latitude,
                                              Longitude,
                                              address
                                            )
                                          }
                                        >
                                          Locate Us
                                        </span>
                                      </div>
                                    </div>
                                  )
                                )}
                            </>
                          )}
                        </div>
                      )}
                      {/* {loadingshow ? <div className="textcentervertex">
                                                <img src={animation} alt="Loading" />
                                                <div className="model_popup">Please Wait...</div>
                                            </div> : ""
                                            }
                                            {DataCities === null ? (
                                                <div className="textCenter">
                                                  
                                                    <h5>No Data Found...</h5>
                                                </div>
                                            ) : (
                                                ""
                                            )} */}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <div className="get-in-touch-left">
            {/* <div className="question-box">
                                    
                                    <p>Kindly share your information, and we will reach out to you.</p>
                                </div> */}
            <div className="add-container">
              <div className="add-head">Corporate Office</div>

              <div className="name">KFin Technologies Limited(KFin)</div>
              <p className="add">
                Selenium Tower B, Plot No. 31 & 32,Financial District,
                Nanakramguda, Serilingampally Mandal, Hyderabad – 500 032.
              </p>

              {/* <div className="tel"><span>Tel. No.:</span>+ 91 (022) 6198 77 77</div> */}
              <div className="tel">
                <span>Toll Free No.:</span> 1800 1038 345
              </div>
            </div>
          </div>
          <div class="sticky-icon">
            <div id="fixed-social">
              <div>
                <div class="fixed-instagrem box" target="_blank">
                  <i class="fa fa-phone-square" style={{color : "#fff"}}></i>
                  <span>
                    <a href="tel:1800 1038 345" className="hover-contact">1800 1038 345</a>
                  </span>
                </div>
              </div>
              <div>
                <div class="fixed-tumblr box">
                  <i class="fa fa-envelope"></i>
                  <span style={{color : "#000"}}>
                    <a href="mailto:investor@jmfl.com">investor@jmfl.com</a>
                  </span>
                  <br></br>
                  <span>
                    <a href="mailto:partnercare@jmfl.com">
                      partnercare@jmfl.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
    </>
  );
}

export default KfinBranches;
